import React, {useCallback} from 'react';
import {FieldRenderProps} from 'react-final-form';
import block from 'bem-cn-lite';
import {RangeInputPicker, RangeInputPickerProps} from '@yandex-data-ui/common';
import {ClassNameProps, FormField, PickKnownFieldProps} from '@yandex-data-ui/cloud-components';

import './FormFieldRangeInputPicker.scss';

const b = block('form-field-range-input-picker');

type HandlerType = 'onUpdate' | 'onAfterUpdate' | 'onBlur' | 'onFocus' | 'onSubmit';
type InputHandlerType = HandlerType | 'onChange';

export interface FormFieldRangeInputPickerProps
    extends PickKnownFieldProps<FieldRenderProps<number, HTMLInputElement>>,
        RangeInputPickerProps,
        ClassNameProps {
    controlClassName?: string;
}

export const FormFieldRangeInputPicker: React.FC<FormFieldRangeInputPickerProps> = (props) => {
    const {meta, input, className, controlClassName, ...controlProps} = props;

    const handleEvent = useCallback(
        (handlerName: InputHandlerType, outerHandlerName?: HandlerType) => (value: number) => {
            input[handlerName]?.(value);
            controlProps[outerHandlerName ?? (handlerName as HandlerType)]?.(value);

            return value;
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            controlProps.onUpdate,
            controlProps.onAfterUpdate,
            controlProps.onBlur,
            controlProps.onFocus,
            controlProps.onSubmit,
            input,
        ],
    );

    return (
        <FormField meta={meta} className={b(null, className)}>
            <RangeInputPicker
                {...controlProps}
                value={input.value || 0}
                className={controlClassName}
                onUpdate={handleEvent('onChange', 'onUpdate')}
                onAfterUpdate={handleEvent('onChange', 'onAfterUpdate')}
                onBlur={handleEvent('onBlur')}
                onFocus={handleEvent('onFocus')}
                onSubmit={handleEvent('onSubmit')}
            />
        </FormField>
    );
};
